import { render, staticRenderFns } from "./MercadoLivreIcon.vue?vue&type=template&id=4abe72bc&"
import script from "./MercadoLivreIcon.vue?vue&type=script&lang=js&"
export * from "./MercadoLivreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports